module.exports = __webpack_public_path__ + "img/quote-banner-v2.78e6a5cf.png";